/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {AdminObjectState, SignalAdminResourceApiBase} from '../common/controller/signal-admin-resource-api';

export interface ReportTranslationModel {
  id: string;
  name?: string;
  description?: string;
  locale?: string;
  defaultTranslation?: string;
  translations?: Record<string, string>;
  objectState?: AdminObjectState;
  validationWarnings?: any[];
}

@Injectable({providedIn: 'root'})
export class ReportTranslationApiService extends SignalAdminResourceApiBase<ReportTranslationModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'reporttranslations');
  }

  getDefaults(): Observable<Record<string, Record<string, string>>> {
    return this.client.request({
      method: 'GET',
      url: this.resourceUri('reporttranslationdefaults'),
      params: {context: null}
    });
  }
}
